import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'
import DOMPurify from 'dompurify'

import { Moment } from 'config/moment'
import { ERRORS } from 'consts'
import { useApiCall } from 'hooks'
import { snackbar } from 'components'
import { COLORS } from 'styles'

import { getCoupons } from './api'
import { DefaultTable } from '../../components'
import { GetCouponsResponse, ParametersDownload, CustomCupon } from './types'

const useStyles = makeStyles({
  title: {
    color: COLORS.BASE,
  },
  divider: {
    backgroundColor: COLORS.BASE,
  },
})

const columns = [
  { title: 'ID', field: 'coupon_id' },

  {
    title: 'Título',
    field: 'coupon.title',
    render: (row: CustomCupon) => (
      // eslint-disable-next-line react/no-danger
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(row.coupon.title) }} />
    ),
  },

  { title: 'Cantidad', field: 'count_coupon' },
]

interface propsUsersStatus {
  startDate: Moment
  endDate: Moment
  storeId: number
}

const CouponsTopFive: React.FC<propsUsersStatus> = ({ startDate, endDate, storeId }) => {
  const [data, setData] = useState<CustomCupon[] | []>([])
  const [requestUsersTags, isLoading] = useApiCall<ParametersDownload, GetCouponsResponse>(() =>
    getCoupons({ startDate, endDate, storeId }),
  )

  useEffect(() => {
    requestUsersTags({ startDate, endDate, storeId })
      .then(resp => {
        setData(resp.data)
      })
      .catch(() => {
        setData([])
        snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDate, startDate, storeId])
  const classes = useStyles()

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" component="h2" className={classes.title}>
          Promos utilizadas
        </Typography>
        <Divider className={classes.divider} />
      </Grid>
      <Grid item xs={12}>
        <DefaultTable
          title="Promos"
          columns={columns}
          data={data}
          isLoading={isLoading}
          options={{ pageSize: 5, toolbar: false }}
        />
      </Grid>
    </>
  )
}

export { CouponsTopFive }
